interface Props {
  title: string;
  onClick: () => void;
}

const PrimaryButton = (props: Props) => {
  return (
    <button
      className="bg-brand rounded-[10px] px-2 py-0.5 text-xs font-bold leading-relaxed text-white"
      onClick={props.onClick}
    >
      {props.title}
    </button>
  );
};

export { PrimaryButton };
